export const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_757a45ec-96b5-46d8-a699-b293eba77467/artifacts/419rdje2_cropped-BeOasis_AgenciaMarketing_Logo-03-2048x562.png";

export const CONTACT = {
  instagram: "https://instagram.com/beoasis",
  linkedin: "https://linkedin.com/company/beoasis",
};
